import HEALTH_SIGNALS from 'app/operations/queries/health-signals';
import { get } from 'lodash';

function formatSignals(signals) {
  return signals.map(signal => {
    return {
      category: get(signal, 'category'),
      evidences: get(signal, 'evidence'),
      error: get(signal, 'error'),
    }
  })
}

const getHealthSignals = (memberId, client) => {
  return client
    .query({
      variables: { id: memberId },
      query: HEALTH_SIGNALS,
    })
    .then(result => {
      const signals = get(result, 'data.member.healthSignals');

      return {
        signals: formatSignals(signals)
      };

    })
    .catch(e => {
      console.error(e);

      return { signals: [], error: 'Failed to get health signals!' };
    });
}

export default getHealthSignals;
